<template>
  <div class="box vs-column vs-align-center vs-space-between">
    <div class="box-top vs-row vs-align-center">
      <img src="../assets/img/logo.png" class="logo">
    </div>
    <div class="box-content vs-row vs-space-center vs-align-center">
      <img src="../assets/img/robot.png" class="box-content-left">
      <div class="box-content-right vs-column">
        <div class="box-content-title">客户端下载</div>
        <div class="box-content-text">“广西法网 · 桂法通 · 终端机APP”整合了法律咨询、法律服务机构和人员信息查询、司法行政业务办理、普法宣传等各项司法行政业务，免费提供24小时热线咨询、留言解答、智能解答，在线申办公证、法律援助等业务。</div>
        <div class="box-content-btn" @click="down()">立即下载</div>
      </div>
    </div>
    <div class="box-bottom vs-row vs-align-center vs-space-center">
      <span>广西法网·桂法通</span>
      <span>版权所有</span>
      <span>: 广西壮族自治区司法厅</span>
      <span>运维技术支持</span>
      <span>: 南宁城市通信息科技有限公司</span>
      <span>0771-5555551</span>
    </div>
  </div>
</template>

<script>
  import { sendRequest } from '@/commons/http/api'
  export default {
    name: 'clientDownload',
    data () {
      const self = this
      return {
      }
    },
    methods: {
      down() {
        sendRequest('terminal/getLaseVersion', {}).then(res => {
          if (res.code === 0) {
            window.location.href = res.data
          }
        })
      }
    }
  }
</script>

<style scoped>
.box {
  width: 100%;
  min-width: 920px;
  height: 100%;
  background-image: url("../assets/img/bg-load.png");
  background-repeat: no-repeat;
  background-size: 100% 100%;
}
.box-top {
  width: 100%;
  height: 119px;
  background-image: url("../assets/img/top-bg.png");
  background-repeat: no-repeat;
  background-size: 100% 100%;
}
.logo {
  width: 334px;
  height: 82px;
  margin-left: 108px;
}
.box-content {
  width: 100%;
}
.box-content-right {
  width: 760px;
  margin-right: 20px;
}
.box-content-left {
  width: 28%;
  /*width: 528px;*/
  /*height: 507px;*/
  margin-left: 80px;
  margin-right: 160px;
}
.box-content-title {
  font-size: 80px;
  color: rgb(27, 27, 27);
  margin-bottom: 63px;
}
.box-content-text {
  font-size: 26px;
  color: rgb(27, 27, 27);
  margin-bottom: 76px;
}
.box-content-btn {
  width: 352px;
  height: 99px;
  line-height: 99px;
  background-image: url("../assets/img/load-btn.png");
  background-repeat: no-repeat;
  background-size: 100% 100%;
  font-size: 34px;
  color: #fff;
  padding-left: 136px;
  font-family: "PingFangSC";
  cursor: pointer;
  margin-bottom: 20px;
}
.box-bottom {
  width: 100%;
  height: 60px;
  background-color: #2c70d1;
  color: #fff;
  font-size: 18px;
}
.box-bottom span {
  margin: 0 8px;
}
  @media (max-width: 1800px) {
  }
  @media (max-width: 1520px) {
  }
</style>




// WEBPACK FOOTER //
// src/views/clientDownload.vue